module.exports = __webpack_public_path__ + "img/footer-wb.64e4b3fd.png";